<template>
	<div id="app">
		<div :class="blacktype==2?'grayscale':''">
			<div v-if="!isPhone">
				<Header></Header>
			</div>
			<router-view></router-view>
			<record v-if="!isPhone"></record>
			<record2 v-if="isPhone"></record2>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Header from "./components/Header";
import record from "./components/record";
import record2 from "./components/record2";
export default {
	name: "app",
	components: {
		Header,
		record,
		record2,
	},
	data() {
		return {
			isPhone: this.$isMobile,
            blacktype:1,
		}
	},
	async mounted() {
		await this.$store.dispatch("getHeadList");
	},
    created(){
        this.jconfig();
    },
    methods:{
        // 配置信息接口
		async jconfig() {
			const res = await this.$api.jconfig();
			if (res.code == 1) {
				this.blacktype = res.data.blacktype;
			}
		},
    }
};
</script>

<style lang="scss">
.grayscale {
  filter: grayscale(100%);
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\'><filter id=\'grayscale\'><feColorMatrix type=\'matrix\' values=\'0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0\'/></filter></svg>#grayscale");
  filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
  -webkit-filter: grayscale(1);
}
@import "@/common/common.scss";
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #333;
}
</style>
